import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { BetSlipItem } from '@mobi/betslip/types'
import { selectBonusCashCampaigns } from '@mobi/betslip/Store/Workflow/selectors'
import { getItemsWithBonusesApplied } from '../Components/Singles/helpers/getItemsWithBonusesApplied'
import { selectMultiInvestment } from '../Store/Bets/selectors'
import { useAppSelector } from '../Store/hooks'

export const useBonusAppliedItems = (items: BetSlipItem[]) => {
  const bonusCashCampaigns = useSelector(selectBonusCashCampaigns)
  const multiInvestment = useAppSelector(selectMultiInvestment)
  const multiReceipt = useAppSelector(state => state.betslip.bets.multiReceipt)

  return useMemo(() => {
    const { betSlipItems, remainingBonusCashCampaigns, betSlipMultiInvestment } =
      getItemsWithBonusesApplied([...items], bonusCashCampaigns, multiInvestment, multiReceipt)

    return { betSlipItems, remainingBonusCashCampaigns, betSlipMultiInvestment }
  }, [items, bonusCashCampaigns, multiInvestment, multiReceipt])
}
